interface ValidationRule {
    regex: RegExp;
    errMsg: string | null;
    missMsg: string;
}

interface ValidationMap {
    [key: string]: ValidationRule;
}

const validationMap: ValidationMap = {
    username: {
        regex: /^.+$/,
        errMsg: null,
        missMsg: 'Username required!',
    },
    password: {
        regex: /^.+$/,
        errMsg: null,
        missMsg: 'Password required!',
    },
};

class Validator {
    private validationMap: ValidationMap;

    constructor() {
        this.validationMap = validationMap;
    }

    validate = (type: string, value: string): { isValid: boolean; errMsg?: string | null; missMsg?: string | null } => {
        if (this.validationMap[type]?.regex?.test(value)) {
            return {
                isValid: true
            };
        }
        return {
            isValid: false,
            errMsg: value?.length ? this.validationMap[type]?.errMsg : null,
            missMsg: !value?.length ? this.validationMap[type]?.missMsg : null,
        };
    };
}

const validator = new Validator();

export default validator;
